function updateForm(id,value)
{
                      console.log("hi22");
        document.getElementById("1").classList.remove("yellow_bg_bl_col");
        document.getElementById("2").classList.remove("yellow_bg_bl_col");
        document.getElementById("3").classList.remove("yellow_bg_bl_col");
        document.getElementById("4").classList.remove("yellow_bg_bl_col");

      // Add class only if not already present
      if (!document.getElementById(id).classList.contains("yellow_bg_bl_col")) 
      {
          console.log("hi2");
          document.getElementById(id).classList.add("yellow_bg_bl_col");
      }        
        //     if(id==1)
    		// {
    		// 	jQuery("#nf-field-121-container").hide();
    		// 	jQuery("#nf-field-21-container, #nf-field-24-container, #nf-field-25-container, #nf-field-26-container, #nf-field-27-container, #nf-field-29-container, #nf-field-30-container ").show();
    		// }
    		// else
    		// {
    		// 	jQuery("#nf-field-21-container, #nf-field-24-container, #nf-field-25-container, #nf-field-26-container, #nf-field-27-container, #nf-field-29-container, #nf-field-30-container ").hide();
    
    		// 	jQuery("#nf-field-121-container").show()
    		// }
    		
    		
    	//jQuery("#nf-field-123").attr('value',value);
    	//document.getElementById('nf-field-123').value = 'new value';
      var g = document.querySelector('#type_of_attendee').value = value;
      console.log(g);
      // Trigger a 'change' event manually
      var s = document.querySelector('#type_of_attendee').dispatchEvent(new Event('change'));
      console.log(s);
    	
    // 	jQuery("#nf-field-122  > option[value *= '"+value+"']  ").attr('selected',true)
    //     var select = document.getElementById("nf-field-122");
    //     select.options.forEach(opt=>{
    //         if(opt.value == value)
    //             opt.selected = true;
    //         })
    		
}

document.addEventListener("DOMContentLoaded", () => {
  const items = document.querySelectorAll('.slide1-right');

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
      }
    });
  }, { threshold: 0.2 });

  items.forEach(item => observer.observe(item));
});


document.addEventListener("DOMContentLoaded", () => {
  const items = document.querySelectorAll('.slide1-left');

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
      }
    });
  }, { threshold: 0.2 });

  items.forEach(item => observer.observe(item));
});





document.addEventListener("DOMContentLoaded", () => {

 var showDiv = document.getElementById("hideDiv1");

  hideDiv.classList.add("active");  

});



// const tabs = document.querySelectorAll("#date-tabs button");
// // Get all tables
// const tables = document.querySelectorAll(".schedule-table");

// const tabs2 = document.querySelectorAll("#date-tabs2 button");
// // Get all tables
// const tables2 = document.querySelectorAll(".schedule-table2");

// Function to hide all tables
function hideAllTables() {

  var tabs = document.querySelectorAll("#date-tabs button");
  // Get all tables
  var tables = document.querySelectorAll(".schedule-table");

  var tabs1 = document.querySelectorAll("#date-tabs1 button");
  // Get all tables
  var tables1 = document.querySelectorAll(".schedule-table1");


  var tabs2 = document.querySelectorAll("#date-tabs2 button");
  // Get all tables
  var tables2 = document.querySelectorAll(".schedule-table2");

  var tabs3 = document.querySelectorAll("#date-tabs3 button");
  // Get all tables
  var tables3 = document.querySelectorAll(".schedule-table3");


  var tabs4 = document.querySelectorAll("#date-tabs4 button");
  // Get all tables
  var tables4 = document.querySelectorAll(".schedule-table4");

  var tabs5 = document.querySelectorAll("#date-tabs5 button");
  // Get all tables
  var tables5 = document.querySelectorAll(".schedule-table5");



  tables.forEach(t => t.style.display = 'none');
  tabs.forEach(b => b.classList.remove('active'));
  tables1.forEach(t => t.style.display = 'none');
  tabs1.forEach(b => b.classList.remove('active'));
  tables2.forEach(u => u.style.display = 'none');
  tabs2.forEach(c => c.classList.remove('active'));
  tables3.forEach(u => u.style.display = 'none');
  tabs3.forEach(c => c.classList.remove('active'));  
  tables4.forEach(u => u.style.display = 'none');
  tabs4.forEach(c => c.classList.remove('active'));  
  tables5.forEach(u => u.style.display = 'none');
  tabs5.forEach(c => c.classList.remove('active'));      
}






// Function to show table for a specific date
function showTableForDate(date) {
    console.log("its");
    hideAllTables();
    // // On load, show first date by default
  // if (tabs2.length > 0) {
  //   const firstDate2 = tabs2[0].getAttribute('data-date2');
  //   showTableForDate2(firstDate2);
  // }
    const table = document.getElementById('table-' + date);
    if (table) {
      table.style.display = 'table';
      // mark active tab
      const btn = document.querySelector('#date-tabs button[data-date="' + date + '"]');
      if (btn) btn.classList.add('active');
    }
}
// Function to show table for a specific date
function showTableForDate1(date) {
    console.log("its");
    hideAllTables();
    // // On load, show first date by default
  // if (tabs2.length > 0) {
  //   const firstDate2 = tabs2[0].getAttribute('data-date2');
  //   showTableForDate2(firstDate2);
  // }
    const table = document.getElementById('table1-' + date);
    if (table) {
      table.style.display = 'table';
      // mark active tab
      const btn = document.querySelector('#date-tabs1 button[data-date1="' + date + '"]');
      if (btn) btn.classList.add('active');
    }
}
function showTableForDate2(date) {
  hideAllTables();
  const table = document.getElementById('table2-' + date);
  if (table) {
    table.style.display = 'table';
    // mark active tab
    const btn = document.querySelector('#date-tabs2 button[data-date2="' + date + '"]');
    if (btn) btn.classList.add('active');
  }
}
function showTableForDate3(date) {
  hideAllTables();
  const table = document.getElementById('table3-' + date);
  if (table) {
    table.style.display = 'table';
    // mark active tab
    const btn = document.querySelector('#date-tabs3 button[data-date3="' + date + '"]');
    if (btn) btn.classList.add('active');
  }
}
function showTableForDate4(date) {
  hideAllTables();
  const table = document.getElementById('table4-' + date);
  if (table) {
    table.style.display = 'table';
    // mark active tab
    const btn = document.querySelector('#date-tabs4 button[data-date4="' + date + '"]');
    if (btn) btn.classList.add('active');
  }
}
function showTableForDate5(date) {
  hideAllTables();
  const table = document.getElementById('table5-' + date);
  if (table) {
    table.style.display = 'table';
    // mark active tab
    const btn = document.querySelector('#date-tabs5 button[data-date5="' + date + '"]');
    if (btn) btn.classList.add('active');
  }
}
// // Set up click listeners
// tabs.forEach(btn => {
//   btn.addEventListener('click', () => {
//     const date = btn.getAttribute('data-date');
//     showTableForDate(date);
//   });
// });

// // On load, show first date by default
// if (tabs.length > 0) {
//   const firstDate = tabs[0].getAttribute('data-date');
//   showTableForDate(firstDate);
// }







// Set up click listeners
// tabs2.forEach(btn2 => {
//   btn2.addEventListener('click', () => {
//     const date2 = btn2.getAttribute('data-date2');
//     showTableForDate2(date2);
//   });
// });
// // On load, show first date by default
// if (tabs2.length > 0) {
//   const firstDate2 = tabs2[0].getAttribute('data-date2');
//   showTableForDate2(firstDate2);
// }











// const btn1 = document.getElementById("button_1");
// const btn2 = document.getElementById("button_2");

// const div1 = document.getElementById("table_container_1");
// const div2 = document.getElementById("table_container_2");

// function showWithFade(showDiv, hideDiv) {
//     hideDiv.classList.remove("visible");
//  //   hideDiv.classList.add("hide_element");

//     showDiv.classList.remove("visible");

//     // Allow browser to register the display change before applying fade
//     setTimeout(() => {
//         showDiv.classList.add("visible");
//     }, 10);
// }

// btn1.addEventListener("click", () => showWithFade(div1, div2));
// btn2.addEventListener("click", () => showWithFade(div2, div1));


// const btn1 = document.getElementById("button_1");
// const btn2 = document.getElementById("button_2");

// const div1 = document.getElementById("table_container_1");
// const div2 = document.getElementById("table_container_2");

// const div1row1 = document.getElementById("table-2025-09-11").style.display = "table";
// const div2row1 = document.getElementById("table2-2025-02-11").style.display = "table";

// Hide both on load
//div1.style.display = "none";
//div2.style.display = "none";

function slideToggle(showDiv1, hideDiv1) {

  document.getElementById("schedule_sec_1").style.display = "none";
  document.getElementById("schedule_sec_2").style.display = "none";

  console.log(showDiv1+' - '+hideDiv1);

  const div1row1 = document.getElementById("table-2026-09-11").style.display = "table";
  const div1row2 = document.getElementById("table1-2026-09-11").style.display = "table";  
  const div2row1 = document.getElementById("table2-2026-02-23").style.display = "table";
  const div2row2 = document.getElementById("table3-2026-03-02").style.display = "table";
  const div3row1 = document.getElementById("table4-2026-09-11").style.display = "table";



      document.getElementById("button_1").addEventListener("click", () => {
          document.querySelector("#schedule_container").scrollIntoView({
              behavior: "smooth",
              block: "start"
          });
      });
      document.getElementById("button_2").addEventListener("click", () => {
          document.querySelector("#schedule_container").scrollIntoView({
              behavior: "smooth",
              block: "start"
          });
      });   



  var showDiv = document.getElementById(showDiv1);
  var hideDiv = document.getElementById(hideDiv1);

    // Slide out the currently visible div
   //// hideDiv.classList.remove("show");
    //hideDiv.classList.add("hidden");
  console.log(showDiv+' - '+hideDiv);

    // After animation ends → fully hide it
    setTimeout(() => {
        hideDiv.style.display = "none";
        hideDiv.classList.remove("hide-out");
    }, 600);

    // Show next div and slide it in
    showDiv.style.display = "block";

    setTimeout(() => {
        showDiv.classList.add("show");
    }, 10);



 
    
 

}


function cityToggle(showDiv, hideDiv, hideDiv2, showDivHead,hideDivHead, hideDivHead2) {

    // Slide out the currently visible div
   //// hideDiv.classList.remove("show");
    //hideDiv.classList.add("hidden");
  console.log(showDiv+' - '+hideDiv);
  console.log(showDivHead+' - '+hideDivHead);

  console.log(document.getElementById(hideDiv));


  console.log(document.getElementById(showDiv));

    var i2 = document.getElementById(hideDiv2).classList.remove("active");
    var i = document.getElementById(hideDiv).classList.remove("active");
    //console.log(i);
    // Show next div and slide it in    
	var j = document.getElementById(showDiv).classList.add("active");


    var k = document.getElementById(hideDivHead).classList.remove("active");
    var k2 = document.getElementById(hideDivHead2).classList.remove("active");	
//console.log(k);
    var l = document.getElementById(showDivHead).classList.add("active");
console.log(l);


console.log(j);
console.log("showdiv" + document.getElementById(showDiv));

var m = document.getElementById(showDiv).getElementsByTagName("button")[0].classList.add("active");  
console.log(m);


var n = document.getElementById(showDiv).getElementsByTagName("table")[0].style.display = 'table';  
console.log(n);



}

//btn1.addEventListener("click", () => slideToggle(div1, div2));
//btn2.addEventListener("click", () => slideToggle(div2, div1));







document.addEventListener("DOMContentLoaded", () => {
    initDropdownToggle(
        "info_detail",      // wrapper
        "dropdown_logo",    // icon
        "secondary_info",   // content to slide
        "image_1",          // content to slide
        "image_2"           // image that fades in
    );
});


function initDropdownToggle(wrapperClass, iconClass, contentClass, img1Class, img2Class) {
    const items = document.querySelectorAll(`.${wrapperClass}`);

    items.forEach(item => {
        const icon = item.querySelector(`.${iconClass}`);
        const content = item.querySelector(`.${contentClass}`);
        const img2 = item.querySelector(`.${img2Class}`);
        const img1 = item.querySelector(`.${img1Class}`);

        icon.addEventListener("click", () => {

            // rotate icon
            icon.classList.toggle("active");

            // slide toggle for content
            if (content.style.maxHeight) {
                content.style.maxHeight = null;
                img2.classList.remove("active");
                img1.classList.remove("shadow");

            } else {
                content.style.maxHeight = content.scrollHeight + "px";
                img2.classList.add("active");
                img1.classList.add("shadow");
            }
        });
    });
}
